export enum PurposeEnum {
    None = "None",
    Stores = "Stores",
    Products = "Products",
    Materials = "Materials",
    Attachments = "Attachments",
    ProjectReport = "ProjectReport",
    Instructions = "Instructions"
}
